class CustomBanner extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
    };
    $(this).css('opacity',1);
    var swiper = new Swiper('.banner-content-container', {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
        el: '.banner-pagination',
        clickable: true,
        },
        breakpoints: {
        769: {
            slidesPerView: 1,
            spaceBetween: 0,
        },
        },
    });

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-banner-section", CustomBanner);


class customRelatedSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        };
        var sectionId = this.getAttribute('sectionid');
        var swiper = new Swiper('.product-slider--' + sectionId, {
        slidesPerView: 1,
        spaceBetween: 10,
        mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
        },
        pagination: {
        el: '.swiper-pagination',
        clickable: true,
        },
        navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        },
        breakpoints: {
        640: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        769: {
            slidesPerView: 3,
            spaceBetween: 24,
        },
        1099: {
            slidesPerView: 4,
            spaceBetween: 24,
        },
        },
    });

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-related-products", customRelatedSlider);

class customProductSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        };

        const deskSpace = Number(this.dataset.deskspace);
        const mobSpace  = Number(this.dataset.mobspace);
        
        var sectionId = this.getAttribute('sectionid');
        var swiper = new Swiper('.product-slider--' + sectionId, {
        slidesPerView: 1,
        spaceBetween: mobSpace,
        mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
        },
        pagination: {
        el: '.swiper-pagination',
        clickable: true,
        },
        navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        },
        breakpoints: {
        640: {
            slidesPerView: 2,
        },
        769: {
            slidesPerView: 3,
            spaceBetween: deskSpace,
        },
        1099: {
            slidesPerView: 4,
        },
        },
    });

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-products-slider", customProductSlider);


class CustomImageSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
    };
    
    var sectionId = this.getAttribute('data-sectionid');
    var prevButtons = document.querySelectorAll('.custom-nav-prev-' + sectionId);
    var nextButtons = document.querySelectorAll('.custom-nav-next-' + sectionId);

    var swiper = new Swiper(".main-slider-" + sectionId, {
        slidesPerView: 1.1,
        spaceBetween: 30,
        loop:true,
        speed:1200,
        centeredSlides: true,  
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        breakpoints: {
            750: {
                slidesPerView: 2,
                spaceBetween: 30,
                centeredSlides: false,
            },
            990: {
                slidesPerView: 3,
                spaceBetween: 30,
                centeredSlides: false,
            },
            1280: {
                slidesPerView: 4,
                spaceBetween: 30,
                centeredSlides: false,
            },
        },
        navigation: false,
    });

    prevButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
        swiper.autoplay.stop();
        swiper.slidePrev(600);
        swiper.autoplay.start();
    });
    });

    nextButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
        swiper.autoplay.stop();
        swiper.slideNext(600);
        swiper.autoplay.start();
    });
    });


    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-image-slider", CustomImageSlider);


class MouseMoveSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
    };

    (function () {
        const wrap = document.getElementById('parallax-wrap');
        if (!wrap) return;

        const layers = Array.from(wrap.querySelectorAll('.mmp-pointer'));
        if (!layers.length) return;

        let mouseX = 0, mouseY = 0;
        let rafId = null;

        function setFromEvent(e){
          const rect = wrap.getBoundingClientRect();
          const x = (e.clientX - rect.left) / rect.width;   // 0..1
          const y = (e.clientY - rect.top) / rect.height;   // 0..1
          mouseX = (x - 0.5) * 2; // -1..1
          mouseY = (y - 0.5) * 2; // -1..1
          if (!rafId) rafId = requestAnimationFrame(update);
        }

        function update(){
          const maxMoveX = 18;  // px
          const maxMoveY = 18;  // px
          const baseScale = 1.08;

          layers.forEach(layer => {
            const depth = parseFloat(layer.getAttribute('data-depth')) || 0.5;
            const tx = mouseX * maxMoveX * depth;
            const ty = mouseY * maxMoveY * depth;
            const t  = `translate3d(${tx}px, ${ty}px, 0) scale(${baseScale})`;
            layer.style.transform = t;
            layer.style.webkitTransform = t;
          });

          rafId = null;
        }

        function reset(){
          layers.forEach(layer => {
            layer.style.transform = 'translate3d(0,0,0) scale(1.08)';
            layer.style.webkitTransform = 'translate3d(0,0,0) scale(1.08)';
          });
        }

        wrap.addEventListener('mousemove', setFromEvent, { passive: true });
        wrap.addEventListener('mouseleave', reset, { passive: true });

        // Touch support
        wrap.addEventListener('touchmove', (e) => {
          if (!e.touches || !e.touches[0]) return;
          setFromEvent(e.touches[0]);
        }, { passive: true });
      })();

  new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("mouse-move-section", MouseMoveSection);


class MainVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
    };
    
    var sectionId = this.getAttribute('data-sectionid');

    var video = $('.myvideo--' + sectionId)[0];
    var video1 = $('.myvideo1--' + sectionId)[0];

    // Initial state for mute
    video.muted = true;
    video1.muted = true;
    $('.muteBtn--' + sectionId).find('.mute').show(); // mute icon visible
    $('.muteBtn--' + sectionId).find('.unmute').hide(); // unmute icon hidden

    // Initial state for play/pause buttons
    if (!video.paused) {
      $('.play-button--' + sectionId).hide();
      $('.pause-button--' + sectionId).show();
    } else {
      $('.play-button--' + sectionId).show();
      $('.pause-button--' + sectionId).hide();
    }

    // Mute / Unmute toggle
    $('.muteBtn--' + sectionId).click(function () {
      if (video.muted) {
        video.muted = false;
        video1.muted = false;
        $(this).find('.mute').hide();
        $(this).find('.unmute').show();
      } else {
        video.muted = true;
        video1.muted = true;
        $(this).find('.mute').show();
        $(this).find('.unmute').hide();
      }
    });

    // Play button click
    $('.play-button--' + sectionId).click(function () {
      video.play();
      video1.play();
      $(this).hide(); // hide play button
      $('.pause-button--' + sectionId).show(); // show pause button
    });

    // Pause button click
    $('.pause-button--' + sectionId).click(function () {
      video.pause();
      video1.pause();
      $(this).hide(); // hide pause button
      $('.play-button--' + sectionId).show(); // show play button
    });

    // Optional: Update buttons if user manually plays/pauses
    video.addEventListener('play', function () {
      $('.play-button--' + sectionId).hide();
      $('.pause-button--' + sectionId).show();
    });
    video.addEventListener('pause', function () {
      $('.play-button--' + sectionId).show();
      $('.pause-button--' + sectionId).hide();
    });


    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("main-video", MainVideo);


class CustomMediaSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
    };


var swiper = new Swiper(".custom-thumbnail-design-slider", {
  spaceBetween: 10,
  slidesPerView: 5,
  freeMode: true,
  watchSlidesProgress: true,
});
var swiper2 = new Swiper(".custom-gallery-design-slider", {
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});

new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-media-gallery", CustomMediaSlider);

class CartUpsell extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
    };

    var swiper = new Swiper('.cart-upsell-slider', {
      slidesPerView: 1,
      spaceBetween: 12,
      breakpoints: {
        640: {
          slidesPerView: 1.2,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: 1.2,
          spaceBetween: 12,
        },
        1024: {
          slidesPerView: 1.5,
          spaceBetween: 12,
        },
      },
    });

new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("cart-upsell", CartUpsell);

class ProductUpsell extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
    };

    var swiper = new Swiper(".upsell-products-wrapper", {
      slidesPerView: 1.5,
      spaceBetween: 16,
      navigation: {
        nextEl: ".upsell-next",
        prevEl: ".upsell-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 2.3,
          spaceBetween: 20,
        },
      },
    });

new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-upsell", ProductUpsell);
